import React from 'react';

import { Alert, CircularProgress, Container, Stack } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import { useGetTaxEstimationControl } from '~/hooks/apis/connection-google/useTaxEstimation';

import TaxEstimationControls from './TaxEstimationControls';
import TaxEstimationPanel from './TaxEstimationPanel';

export default function TaxEstimationPage() {
  const query = useGetTaxEstimationControl();
  return (
    <Container maxWidth="xl">
      <PageSubheader title="Government tax estimates" />
      <Stack spacing={3}>
        <Stack spacing={2}>
          {query.isPending ? (
            <CircularProgress aria-label="Loading tax controls" />
          ) : query.isError ? (
            <Alert severity="error">Unable to load tax estimation controls.</Alert>
          ) : (
            <TaxEstimationControls key={`${query.data.mode}:${query.data.sampleRate}`} control={query.data} />
          )}
        </Stack>
        <TaxEstimationPanel />
      </Stack>
    </Container>
  );
}
